import PropTypes from "prop-types";

import { CustomContainer, Text } from "components/atoms/DependencyHelper";

import styles from "./svgWithText.module.scss"
import config from "../../../config/index";

const TextIconTypes = {
  Data: "data",
  SMS: "sms",
  Phone: "phone",
  Combo: "combo",
};

const SvgWithText = ({
  className,
  description,
  iconType,
  owlDescription,
  owlValue,
  value,
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  
  let iconUrl = '';

  switch(iconType) {
    case TextIconTypes.Data:
      iconUrl = `${imagePrefix}/assets/images/plan-data.svg`;
      break;
    case TextIconTypes.SMS:
      iconUrl = `${imagePrefix}/assets/images/plan-sms.svg`
      break;
    case TextIconTypes.Phone:
      iconUrl = `${imagePrefix}/assets/images/plan-phone.svg`
      break;
    case TextIconTypes.Combo:
      iconUrl = `${imagePrefix}/assets/images/plan-combo.svg`
      break;
    default:
      iconUrl = '';
      break;
  }

  return (
    <CustomContainer className={`${styles["detail-container"]} ${className}`}> 
      <CustomContainer className={styles["svg-icon"]}>
        <img src={iconUrl} />
      </CustomContainer>

      <CustomContainer className={styles["description"]}>
        <Text className={styles["value"]}>{ value }</Text>
        <Text className={styles["type"]}>{ description }</Text>

        {(owlValue && owlDescription) && 
          <>
            <Text className={styles["value"]}>+</Text>
            <Text className={styles["value"]}>{ owlValue }</Text>
            <Text className={styles["type"]}>{ owlDescription }</Text>
          </>
        }
      </CustomContainer>
        
    </CustomContainer>
  );
};

SvgWithText.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  iconType: PropTypes.string,
  owlDescription: PropTypes.string,
  owlValue: PropTypes.string,
  value: PropTypes.string,
}

export default SvgWithText;
